export default "__VITE_ASSET__D1BGs$lF__"